var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.53616C15.5 5.68579 15 8.72818 13.5 9.97506C15.5 2.5 8 1 8 1C8 1 9.15 4.73815 7.5 6.53367C7.4 4.48878 6.25 3.2419 6.25 3.2419C5.4 6.93267 2.5 10.1247 2.5 12.5187C2.5 16.6584 5.85 20 10 20C14.15 20 17 17 17.5 12.5187C17.5 9.52618 17.5 7.5 15.5 5.53616Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.1786C12.5 16.4786 11.4 17.5 10 17.5C8.6 17.5 7.5 16.4786 7.5 15.1786C7.5 13.8786 10 9.375 10 9.375C10 9.375 12.5 13.8786 12.5 15.1786Z",
    fill: "#F2A376"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMeter);
export default __webpack_public_path__ + "static/media/heat-meter.e87f3d693cfcef295005735f824a49b0.svg";
export { ForwardRef as ReactComponent };